import Main from "@/layout/main.vue";
import Blank from "@/layout/blank.vue";
const routes = [
    {
        path: "/statistics",
        name: "statistics",
        meta: { title: "统计" },
        redirect: "/statistics/shop",
        component: Main,
        children: [
            {
                path: "/statistics/shop",
                name: "statistics_shop",
                meta: {
                    title: "资金明细",
                    icon: "icon_fenxiao_order",
                    parentPath: "/statistics",
                    permission: ["view"],
                },
                component: () => import("@/views/statistics/shop.vue"),
            },
            {
                path: "/statistics/log",
                name: "statistics_log",
                meta: {
                    title: "导出队列",
                    icon: "icon_fenxiao_order",
                    parentPath: "/statistics",
                    permission: ["view"],
                },
                component: () => import("@/views/statistics/log.vue"),
            },
            {
                path: "/statistics/ledger_statistics",
                name: "statistics_ledger_statistics",
                meta: {
                    title: "账户统计数据",
                    icon: "icon_fenxiao_order",
                    parentPath: "/statistics",
                    permission: ["view"],
                },
                component: () => import("@/views/statistics/ledger_statistics.vue"),
            },
        ],
    },
];
export default routes;
